module.exports = __webpack_public_path__ + "static/why-health.1ec9f4fe.jpg";